import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.folharaplicativo.cadastra(payload).then(res => {
        dispatch('ActionSetFolharId',res)
    }).catch(err => {
        dispatch('ActionSetFolharId',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.folharaplicativo.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisaAplicativo = ({dispatch},payload)=>{
    return serves.folharaplicativo.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}
export const ActionPesquisaTrabalhador = ({dispatch},payload)=>{
    return serves.folharaplicativo.pesquisatrabalhador(payload).then(res => {
        dispatch('ActionSetTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetTrabalhador',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.folhar.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.folhar.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.folhar.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}


export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetTrabalhador = ({commit},payload) =>{
    commit(types.SET_TRABALHADOR,payload)
}
export const ActionSetSevicoGeral = ({commit},payload) =>{
    commit(types.SET_GERAL,payload)
}
export const ActionSetValorCalculo = ({commit},payload) =>{
    commit(types.SET_VALORCALCULO,payload)
}
export const ActionSetValorCalculoGeral = ({commit},payload) =>{
    commit(types.SET_VALORCALCULO_GERAL,payload)
}
export const ActionSetComissionado = ({commit},payload) =>{
    commit(types.SET_COMISSIONADOR,payload)
}
export const ActionSetDias = ({commit},payload) =>{
    commit(types.SET_DIAS,payload)
}
export const ActionSetBaseCalculo = ({commit},payload) =>{
    commit(types.SET_BASECALCULO,payload)
}
export const ActionSetFolharId = ({commit},payload) =>{
    commit(types.SET_FOLHAR_ID,payload)
}
export const ActionSetQuizena = ({commit},payload) =>{
    commit(types.SET_QUINZENA,payload)
}
